export default __webpack_public_path__ + "./assets/img/logo-quebra-dona-footer.png";